import React from "react";
import ProductDetailsIndex from "../components/productDetails/index";
import Footer from "../components/commonComponents/footer";
import Navbar from '../components/commonComponents/Navbar/Navbar';
import { useSelector } from "react-redux";
import PageLoader from "../common/pageLoader";
import { url } from "../utils/constant";

export default function ProductDetails() {

    const { pageLoader } = useSelector(state => state.commonReducer);

    return (
        <div className={`${pageLoader && "body-overflow-hide"}`}>
            {/* <TopNavbar /> */}
            {pageLoader &&
                <PageLoader />
            }
            <Navbar />
            <ProductDetailsIndex />
            <Footer />
        </div>
    )
}